import { Component, OnInit, HostBinding, 
         trigger, transition, animate,
         style, state } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import 'rxjs/add/operator/switchMap';
import { ToastsManager }  from 'ng2-toastr';

import { EmployeesData, EmployeesService }  from './Employees.service';


@Component({
  template: require('./EmployeesDetails.component.html'),
  providers: [EmployeesService
	
	],
  animations: [
    trigger('routeAnimation', [
      state('*',
        style({
          opacity: 1,
          transform: 'translateX(0)'
        })
      ),
      transition(':enter', [
        style({
          opacity: 0,
          transform: 'translateX(-100%)'
        }),
        animate('0.2s ease-in')
      ]),
      transition(':leave', [
        animate('0.5s ease-out', style({
          opacity: 0,
          transform: 'translateY(100%)'
        }))
      ])
    ])
  ]
})

export class EmployeesDetailsComponent implements OnInit {
	@HostBinding('@routeAnimation') get routeAnimation() {
		return true;
	}

	@HostBinding('style.display') get display() {
		return 'block';
	}

	// @HostBinding('style.position') get position() {
	//  return 'absolute';
	// }
  
	objEmployees: EmployeesData;
	errorMessage: string;
	messages: string[];

	// Lookup Arrays
	
	EmployeesList: EmployeesData[];

	constructor(private route: ActivatedRoute, 
		private router: Router, 
		private toastr: ToastsManager,
		private EmployeesService: EmployeesService

	) {
		// this.id = parseInt(params.get('id'));
		this.objEmployees = new EmployeesData();
	}

	ngOnInit() {
		this.route.params
		// (+) converts string 'id' to a number
		// .switchMap((params: Params) => this.EmployeesService.getByID(+params['id']))
		.switchMap((params: Params) => this.EmployeesService.getByID(params['id']))
		.subscribe((item: EmployeesData) => this.objEmployees = item);
		this.getLookups();
	}

	deleteEmployees(id: number) {
		if (window.confirm('Are you sure you want to delete this Employees?') == true)
		{
			this.EmployeesService.deleteEmployees(this.objEmployees.EmployeeID.toString())
			.subscribe(record => this.router.navigate(['/Employees']),
				error =>  this.errorMessage = 'There was an error while deleting record. Error: ' + <any>error,
				() => { console.log('Employees record deleted successfully...'); }
			);
		}
	}
	gotoEmployeesEdit() {
		this.router.navigate(['/Employees', this.objEmployees.EmployeeID]);
	}

	gotoEmployees() {
		this.router.navigate(['/Employees']);
	}

	// Get Lookup List for Employees
    getEmployees() {
		this.EmployeesService.getAll().subscribe(records => this.EmployeesList=records);
    }

	getLookups() {

        this.getEmployees();
	}

	log(msg: string) {
		this.messages.splice(0, 0, msg);
		console.log(msg);
	}
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/Employees/EmployeesDetails.component.ts